import Vue from 'vue';
import Router from 'vue-router';
import store from './store';


 
Vue.use(Router);

const router = new Router({
    // 🎈 @mattia da scommentare quando in produzione, su goku altrimenti non funziona
    //mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: '/login',
            name: 'route-login',
            meta: {
                guest: true
            },
            component: () => import('./views/account/login/ViewLogin.vue')
            
        },
        {
            path: '/forgot',
            name: 'route-forgot',
            meta: {
                guest: true
            },
            component: () => import('./views/account/login/ViewForgot.vue')
            
        },
        {
            path: '/expired',
            name: 'route-expired',
            meta: {
                guest: false
            },
            component: () => import('./views/account/login/ViewExpired.vue')
            
        },
        {
            path: '/oblivion',
            name: 'route-oblivion',
            meta: {
                guest: true
            },
            component: () => import('./views/account/login/ViewOblivion.vue')
            
        },
        {
            path: '/oblivionconfirm/:id',
            name: 'route-oblivion-confirm',
            meta: {
                guest: true
            },
            component: () => import('./views/account/login/ViewOblivionConfirm.vue')
            
        },
        {
            path: '/',
         
            name: 'route-index',
            component: () => import('./views/company/list.vue'),
            meta: {
                auth: true,
                label: "Home"
            },
        },
        {
            path: '/utenti/:id',
            name: 'route-user-edit',
            meta: {
                auth: true,
                label:"Utente"

            },
            component: () => import('./views/user/save.vue')
        }
        ,
        {
            path: '/utenti',
            name: 'route-user-list',
            meta: {
                auth: true,
                label:"Utenti"

            },
            component: () => import('./views/user/list.vue')
        },
        {
            path: '/profili/:id',
            name: 'route-profile-edit',
            meta: {
                auth: true,
                label:"Profilo"

            },
            component: () => import('./views/profile/save.vue')
        }
        ,
        {
            path: '/profili',
            name: 'route-profile-list',
            meta: {
                auth: true,
                label:"Profili"

            },
            component: () => import('./views/profile/list.vue')
        },
        {
            path: '/tagtype/list',
            name: 'route-tagtype-list',
            meta: {
                auth: true,
                label:"Tipologia tags"
               
            },
            component: () => import('./views/tagtype/list.vue')
        },
        {
            path: '/tagtype/:id',
            name: 'route-tagtype-edit',
            meta: {
                auth: true,
                label:"Tipologia tag"

            },
            component: () => import('./views/tagtype/save.vue')
        },
        {
            path: '/tag/list',
            name: 'route-tag-list',
            meta: {
                auth: true,
                label:"Tags"
            },
            component: () => import('./views/tag/list.vue')
        },
        {
            path: '/tag/:id',
            name: 'route-tag-edit',
            meta: {
                auth: true,
                label:"Tag"
            },
            component: () => import('./views/tag/save.vue')
        },
        {
            path: '/newsletter/list',
            name: 'route-newsletter-list',
            meta: {
                auth: true,
                label:"Comunicazioni"

            },
            component: () => import('./views/newsletter/list.vue')
        },
        {
            path: '/newsletter/:id',
            name: 'route-newsletter-edit',
            meta: {
                auth: true,
                label:"Comunicazione"

            },
            component: () => import('./views/newsletter/save.vue')
        },
        {
            path: '/company/list',
            name: 'route-company-list',
            meta: {
                auth: true,
                label:"Clienti"

            },
            component: () => import('./views/company/list.vue')
        },
        {
            path: '/company/:id',
            name: 'route-company-edit',
            meta: {
                auth: true,
                label:"Cliente"

            },
            component: () => import('./views/company/save.vue')
        }
        ,
        {
            path: '/messagetemplate/list',
            name: 'route-messagetemplate-list',
            meta: {
                auth: true,
                label:"Template Messaggi"

            },
            component: () => import('./views/messageTemplate/list.vue')
        },
        {
            path: '/messagetemplate/:id',
            name: 'route-messagetemplate-edit',
            meta: {
                auth: true,
                label:"Messaggio"

            },
            component: () => import('./views/messageTemplate/save.vue')
        }
        ,
        {
            path: '/office/:pid/:id',
            name: 'route-office-edit',
            meta: {
                auth: true,

            },
            component: () => import('./views/office/save.vue')
        }
        ,
        {
            path: '/page/error',
            name: 'route-error',
            meta: {
                guest: true
            },
            component: () => import('./views/pages/ViewError.vue')
        },
        {
            path: '/macro/list',
            name: 'route-macro-list',
            meta: {
                auth: true,
                label:"Elenco macro"

            },
            component: () => import('./views/macro/list.vue')
        },
        {
            path: '/macro/:id',
            name: 'route-macro-edit',
            meta: {
                auth: true,
                label:"Macro"

            },
            component: () => import('./views/macro/save.vue')
        },
        {
            path: '/kiosk/import',
            name: 'route-kiosk-import',
            meta: {
                auth: true,
                label:"Importazione statistiche"

            },
            component: () => import('./views/kiosk/import.vue')
        },
        {
            path: '/kiosk/stats',
            name: 'route-kiosk-stats',
            meta: {
                auth: true,
                label:"Statistiche"

            },
            component: () => import('./views/kiosk/list.vue')
        },
        {
            path: '/kiosk/notes',
            name: 'route-kiosk-notes',
            meta: {
                auth: true,
                label:"Note"

            },
            component: () => import('./views/kiosk/note.vue')
        }
    ]
});



router.beforeEach((to, from, next) => {

    if (localStorage.getItem('crm-api')) {
        if (!store.getters.isAuthenticated) {
            store.dispatch('autoLogin');
            
            

        }
        if(store.state.user.expired && to.name != "route-expired"){
            next({
                name: 'route-expired',
                replace: true
            });
            
            return;

        }
    }

  
    

    if (to.matched.some(record => record.meta.auth)) {
      
        if (!store.getters.isAuthenticated) {
            next({
                path: '/login',
                replace: true
            });
            return;
        }

        store.dispatch('fetchTagTypes');
      
    }
   
    next();
    if(window.SetMenu) setTimeout(window.SetMenu,200);
});




export default router;
